import React from 'react'
import PropTypes from 'prop-types'
import Header from 'components/header/container'
import Footer from 'components/footer'

class App extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      tenant: null,
      user: null
    }

    this.handleTenantUserSelected = this.handleTenantUserSelected.bind(this)
  }

  getChildContext () {
    return {
      tenant: this.state.tenant,
      user: this.state.user
    }
  }

  handleTenantUserSelected ({ tenant, user }) {
    this.setState({
      tenant,
      user
    })
  }

  render () {
    const { children } = this.props

    return (
      <div>
        <Header onTenantUserSelect={this.handleTenantUserSelected} />
        {children}
        <Footer />
      </div>
    )
  }
}

App.propTypes = {
  children: PropTypes.any
}

App.childContextTypes = {
  tenant: PropTypes.object,
  user: PropTypes.object
}

export default App



// WEBPACK FOOTER //
// ./src/components/app/app.js